import React from 'react'
import PropTypes from 'prop-types'

import { keys, isString } from 'lodash'

import classes from 'classnames'

import { ui } from '../redux'

import PanelHeading from '../components/PanelHeading'
import LoadingIndicator from '../components/LoadingIndicator'

import './Panel.css'

const Panel = (props) => {
    const {
        title, subtitle, tools, border,
        hasTable, hasContrast, hasTabs, withoutPadding, withDivider,
        isLoading, heading,
        className, children
    } = props

    return (
        <div
            className={
                classes(
                    'panel panel-default',
                    isLoading ? ['be-loading', 'be-loading-active'] : null,
                    isString(border) ? ['panel-border-color', `panel-border-color-${border}`] : null,
                    { 'panel-table': hasTable },
                    { 'panel-unpadded': withoutPadding },
                    className
                )
            }
        >
            <PanelHeading
                title={ title }
                subtitle={ subtitle }
                withDivider={ (hasTabs === false && hasTable === false) || withDivider }
                tools={ tools }
            >
                { heading }
            </PanelHeading>
            <LoadingIndicator isVisible={ isLoading } />
            <div className={ classes({ 'panel-body': !hasTabs }, { 'panel-body-contrast': hasContrast }) }>
                { children }
            </div>
        </div>
    )
}

Panel.propTypes = {
    title          : PropTypes.node,
    subtitle       : PropTypes.node,
    tools          : PropTypes.node,
    heading        : PropTypes.node,
    border         : PropTypes.oneOfType([PropTypes.oneOf(keys(ui.INTENT)), PropTypes.bool]),
    isLoading      : PropTypes.bool,
    hasTable       : PropTypes.bool,
    hasTabs        : PropTypes.bool,
    hasContrast    : PropTypes.bool,
    withDivider    : PropTypes.bool,
    withoutPadding : PropTypes.bool
}

Panel.defaultProps = {
    border         : false,
    isLoading      : false,
    hasTable       : false,
    hasTabs        : false,
    hasContrast    : false,
    withDivider    : false,
    withoutPadding : false
}

export default Panel
